import { Expose, Type } from 'class-transformer';
import { Point } from 'geojson';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { FususRegionCode } from '../constants';
import { SnLayer, SnLayerHit } from '../layer';
import { SnPlan } from './organization-plan';
import { SnOrganizationSettings } from './organization-settings';

export class SnMou extends SnModel {
  @Expose()
  public mouTemplate: string;
  @Expose()
  public updatedTimestamp: Date;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}

export class SnOrganization extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public publicName: string;

  @Expose()
  public registryHasMou: boolean;

  @Expose()
  public registryRequireEmailConfirmation: boolean;

  @Expose()
  public settings: SnOrganizationSettings;

  @Expose()
  public name: string;

  @Expose()
  public favicoUrl: string;

  @Expose()
  public loginVideoUrl: string;

  @Expose()
  public logoUrl: string;

  @Expose()
  public supportUrl: string;

  @Expose()
  public allowRegistry: boolean;

  @Expose()
  public backgroundUrl: string;

  @Expose()
  public registryRedirectUrl: string;

  @Expose()
  public enabledIntegrations: string[];

  @Expose()
  public registryContent: string;

  @Expose()
  public childOrganizations: string[];

  @Expose()
  public hubspotId: string;

  @Expose()
  public creatorObjectId: string;

  @Expose()
  @ExposeRawData()
  public geometry?: Point;

  @Expose()
  @Type(() => SnMou)
  public mou: SnMou;

  @Expose()
  @Type(() => SnPlan)
  public plan: SnPlan;

  @Expose()
  public additionalData: any;

  @Expose()
  public isExternallyManaged: boolean;

  @Expose()
  public region?: FususRegionCode;

  @Expose()
  public distance: number;

  @Expose()
  public type: string;

  public layers: SnLayer[];
  public layerHits: SnLayerHit[];
  public priorityMap: any;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }

  public get displayName(): string {
    return this.publicName || this.name;
  }

  get position(): Point {
    return this.geometry || this.settings.geometry;
  }
}
